import React, { Component } from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, Toggle, SelectField, MenuItem } from "material-ui"
import strings from "../../localization/strings"
import SimpleTimeEditor from "../../components/common/SimpleTimeEditor"
import { IJobStatus, IMassJobEdit } from "../../models"
import AccountStore from "../../stores/AccountStore"
import * as api from "../../api"
import JobMassShiftEditConfirmationDialog from "./JobMassShiftEditConfirmationDialog"
interface IProps {
    onClose: () => void
    jobIds: string[]
    handleSaveMassEdit: (data: IMassJobEdit) => void
}
interface IState {
    statuses: IJobStatus[]
    showConfirmationDialog: boolean
    massJobEditData: IMassJobEdit
}

export default class JobMassShiftEditDialog extends Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            statuses: [],
            showConfirmationDialog: false,
            massJobEditData: {
                JobIds: this.props.jobIds,
                ChangeShiftStartTime: false,
                ChangeShiftEndTime: false,
                CanAddNote: false,
                ChangeJobStatus: false,
                StartTime: AccountStore.ScheduleVirtualSimpleTime,
                EndTime: AccountStore.ScheduleVirtualSimpleTime,
                JobStatus: undefined,
                Note: "",
                AccountId: AccountStore.getCurrentAccount().Id,
                ChangeActiveStatus: false,
                Active: true,
            }
        }
        autobind(this)
    }

    componentDidMount() {
        this.getJobStatuses()
    }

    getJobStatuses() {
        api.getJobStatuses(AccountStore.getCurrentAccount().Id).then((res) => this.setState({ statuses: res.data }))
    }

    handleSave() {
        this.setState({ showConfirmationDialog: false }, () => this.props.handleSaveMassEdit(this.state.massJobEditData))
    }

    isButtonDisabled() {
        const { massJobEditData } = this.state
        if (!massJobEditData.ChangeJobStatus && !massJobEditData.ChangeShiftEndTime && !massJobEditData.ChangeShiftStartTime && !massJobEditData.CanAddNote && !massJobEditData.ChangeActiveStatus) return true;
        else if (massJobEditData.ChangeJobStatus && !massJobEditData.JobStatus) return true;
        else return false
    }

    render() {
        const { massJobEditData, statuses, showConfirmationDialog } = this.state
        const isCRMAndScheduledEnabled = AccountStore.getCRMEnabled() && AccountStore.getScheduleEnabled()
        return (
            <Dialog
                open
                title={strings.Mass_Edit}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                autoScrollBodyContent={true}
                actions={[
                    <FlatButton label={strings.CANCEL} secondary onClick={this.props.onClose} />,
                    <FlatButton label={strings.Review_Changes} disabled={this.isButtonDisabled()} primary onClick={() => this.setState({ showConfirmationDialog: true })} />
                ]}
            >
                <div style={{ padding: 10 }}>
                    {isCRMAndScheduledEnabled ? strings.formatString(strings.x_Editing_Mass_Shifts, this.props.jobIds.length) : strings.formatString(strings.x_Editing_Mass_Shifts_For_CRM_Disabled, this.props.jobIds.length)}
                    <div style={{ display: "flex", flexDirection: "column", width: "70%", margin: "20px 0px" }}>
                        {isCRMAndScheduledEnabled && 
                            <div>
                                <Toggle
                                    toggled={massJobEditData.ChangeShiftStartTime}
                                    onToggle={(event, value: boolean) => this.setState({ massJobEditData: { ...massJobEditData, ChangeShiftStartTime: value } })}
                                    labelPosition="left"
                                    label={strings.Edit_Shift_Start_Time}
                                    style={{ maxWidth: 450, marginBottom: 15 }}
                                />
                                <Toggle
                                    toggled={massJobEditData.ChangeShiftEndTime}
                                    onToggle={(event, value: boolean) => this.setState({ massJobEditData: { ...massJobEditData, ChangeShiftEndTime: value } })}
                                    labelPosition="left"
                                    label={strings.Edit_Shift_End_Time}
                                    style={{ maxWidth: 450, marginBottom: 15 }}
                                />
                                <Toggle
                                    toggled={massJobEditData.ChangeJobStatus}
                                    onToggle={(event, value: boolean) => this.setState({ massJobEditData: { ...massJobEditData, ChangeJobStatus: value } })}
                                    labelPosition="left"
                                    label={strings.Edit_Job_Status}
                                    style={{ maxWidth: 450, marginBottom: 15 }}
                                />
                            </div>
                        }
                        <Toggle
                            toggled={massJobEditData.CanAddNote}
                            onToggle={(event, value: boolean) => this.setState({ massJobEditData: { ...massJobEditData, CanAddNote: value } })}
                            labelPosition="left"
                            label={strings.Add_Note}
                            style={{ maxWidth: 450, marginBottom: 15 }}
                        />
                        <Toggle
                            toggled={massJobEditData.ChangeActiveStatus}
                            onToggle={(event, value: boolean) => this.setState({ massJobEditData: { ...massJobEditData, ChangeActiveStatus: value } })}
                            labelPosition="left"
                            label={strings.Edit_Job_Active_Status}
                            style={{ maxWidth: 450, marginBottom: 15 }}
                        />
                        {massJobEditData.ChangeShiftStartTime &&
                            <div>
                                <SimpleTimeEditor
                                    label={strings.New_Start_Time}
                                    simpleTime={massJobEditData.StartTime}
                                    handleChange={(startTime) => this.setState({ massJobEditData: { ...massJobEditData, StartTime: startTime } })}
                                />
                            </div>
                        }
                        {massJobEditData.ChangeShiftEndTime &&
                            <div>
                                <SimpleTimeEditor
                                    label={strings.New_End_Time}
                                    simpleTime={massJobEditData.EndTime}
                                    handleChange={(endTime) => this.setState({ massJobEditData: { ...massJobEditData, EndTime: endTime } })}
                                />
                            </div>
                        }
                        {massJobEditData.ChangeJobStatus && (
                            <div style={{ width: 255, display: "flex" }}>
                                <SelectField
                                    floatingLabelText={strings.Status}
                                    value={(massJobEditData.JobStatus && massJobEditData.JobStatus.Id && massJobEditData.JobStatus.Id) || ""}
                                    onChange={(event, key, value) => {
                                        this.setState({ massJobEditData: { ...massJobEditData, JobStatus: statuses.find((status) => status.Id === value) } })
                                    }}
                                    style={{ marginRight: 8 }}
                                >
                                    {statuses.filter(i => i.Active).map((item, index) => (
                                        <MenuItem key={item.Id} value={item.Id} primaryText={item.Name} />
                                    ))}
                                </SelectField>
                                <SelectField
                                    floatingLabelText={strings.Substatus}
                                    value={
                                        (massJobEditData.JobStatus &&
                                            massJobEditData.JobStatus.JobSubStatus &&
                                            massJobEditData.JobStatus.JobSubStatus.Id &&
                                            massJobEditData.JobStatus.JobSubStatus.Id) ||
                                        ""
                                    }
                                    disabled={!massJobEditData.JobStatus}
                                    onChange={(event, key, value) => {
                                        this.setState({
                                            massJobEditData: {
                                                ...massJobEditData,
                                                JobStatus: {
                                                    ...massJobEditData.JobStatus,
                                                    JobSubStatus: massJobEditData.JobStatus.SubStatuses.find((subStatus) => subStatus.Id === value)
                                                }
                                            }
                                        })
                                    }}
                                >
                                    {massJobEditData.JobStatus && massJobEditData.JobStatus.SubStatuses.filter(i => i.Active).map((item, index) => <MenuItem key={item.Id} value={item.Id} primaryText={item.Name} />)}
                                </SelectField>
                            </div>
                        )}
                        {massJobEditData.CanAddNote && (
                            <TextField
                                floatingLabelText={strings.Note}
                                value={massJobEditData.Note}
                                onChange={(e, Note: string) => {
                                    this.setState({ massJobEditData: { ...massJobEditData, Note } })
                                }}
                                fullWidth={true}
                            />
                        )}
                        {massJobEditData.ChangeActiveStatus && (
                            <SelectField
                                floatingLabelText={strings.Active_Status}
                                value={massJobEditData.Active}
                                onChange={(event, key, Active) =>
                                    this.setState({ massJobEditData: { ...massJobEditData, Active } })
                                }
                            >
                                <MenuItem value={true} primaryText={strings.Active} />
                                <MenuItem value={false} primaryText={strings.Inactive} />
                            </SelectField>
                        )}
                    </div>
                    {showConfirmationDialog && (
                        <JobMassShiftEditConfirmationDialog onClose={() => this.setState({ showConfirmationDialog: false })} massJobEditData={massJobEditData} handleSave={this.handleSave} />
                    )}
                </div>
            </Dialog>
        )
    }
}
